export class ConfigTransformer {
  static transform(obj) {
    let config = {};

    config.id = obj.id;
    config.coreId = obj.attributes.core_id;
    config.config = obj.attributes.config;

    return config;
  }
}
